import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import moment from 'moment';
import { fetchProjectsForEventThunk, submitProjectsThunk } from '../redux/fetchProjectsThunk';
import userStore from '../../../zustand/userStore';

const AwarenessProjectsTab = ({ item }) => {
  const dispatch = useDispatch();
  const userData = userStore((state) => state.user);
  const user_id = userData?.id;
  console.log("Item prop:", item);

  const category_id = item?.type === "awarenessDay" ? 1 : 2; // fallback to 2 for celebrations
  const categoryKey = category_id === 1 ? "awareness" : "celebration";

  const { eventDetails } = useSelector((state) => state.projects);
  const { projects = [], loading, error } = eventDetails[categoryKey];

  const [selectedProjectIds, setSelectedProjectIds] = useState([]);

  useEffect(() => {
    if (item?.awareness_id) {
      dispatch(fetchProjectsForEventThunk({ category_id, event_id: item.awareness_id }));
    }
  }, [item?.awareness_id, category_id, dispatch]);

  const handleCheckboxChange = (id) => {
    setSelectedProjectIds(prev =>
      prev.includes(id) ? prev.filter(pid => pid !== id) : [...prev, id]
    );
  };

  const handleSubmit = () => {
    if (!item?.awareness_id) {
      alert("Event ID is missing.");
      return;
    }

    const school_id = 1;
    if (!user_id) {
      alert("User ID is missing.");
      return;
    }

    const is_awareness = item.type === "awarenessDay" ? "1" : "0";
    const is_celebration = item.type === "celebration" ? "1" : "0";

    const projectPayloads = selectedProjectIds.map((projectId) => ({
      school_id,
      user_id,
      project_id: projectId,
      event_id: item.id,
      is_awareness,
      is_celebration,
    }));

    dispatch(submitProjectsThunk({ projectPayloads }))
      .unwrap()
      .then(() => {
        alert("Projects submitted successfully!");
        setSelectedProjectIds([]);
      })
      .catch((error) => {
        console.error("Submission error:", error);
        alert("Failed to submit projects.");
      });
  };

  const applyMultiColumn = projects.length > 10; // Changed from 20 to 10 for demonstration as per updated request

  return (
    <div className="card card-body">
      <h3 className="my-0 text-18">Projects for {item?.name || item?.details}</h3>

      {loading && <p>Loading...</p>}
      {error && <p className="text-danger">Error: {error}</p>}

      {!loading && projects.length === 0 && (
        <p>No projects found for this awareness event.</p>
      )}

      {/* Outer scrollable container */}
      <div style={{ maxHeight: '500px', overflowY: 'auto', border: '1px solid #e0e0e0', padding: '10px' }}>
        {/* Inner content container with conditional multi-column */}
        <div
          className="accordion"
          id="projectAccordion"
          style={applyMultiColumn ? { display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: '15px' } : {}}
        >
          {projects.map((project, index) => (
            <div className="accordion-item" key={project.id}>
              <h2 className="accordion-header" id={`heading${project.id}`}>
                <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target={`#collapse${project.id}`} aria-expanded="false" aria-controls={`collapse${project.id}`}>
                  <input
                    type="checkbox"
                    className="form-check-input me-2"
                    checked={selectedProjectIds.includes(project.id)}
                    onChange={() => handleCheckboxChange(project.id)}
                  />
                  <span className="fw-bold me-2">{index + 1}.</span> {project.project_name}
                </button>
              </h2>
              <div id={`collapse${project.id}`} className="accordion-collapse collapse" aria-labelledby={`heading${project.id}`} data-bs-parent="#projectAccordion">
                <div className="accordion-body">
                  <p><strong>Description:</strong> {project.project_description}</p>

                  {project.children && project.children.length > 0 && (
                    <>
                      <hr />
                      <p><strong>Sub Projects:</strong></p>
                      <ul className="list-group">
                        {project.children.map(child => (
                          <li className="list-group-item d-flex align-items-center" key={child.id}>
                            <input
                              type="checkbox"
                              className="form-check-input me-2"
                              checked={selectedProjectIds.includes(child.id)}
                              onChange={() => handleCheckboxChange(child.id)}
                            />
                            <div>
                              <strong>{child.project_name || child.name}</strong>
                            </div>
                          </li>
                        ))}
                      </ul>
                    </>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {selectedProjectIds.length > 0 && (
        <div className="text-end mt-3">
          <button className="btn btn-success" onClick={handleSubmit}>Submit Selected Projects</button>
        </div>
      )}
    </div>
  );
};

export default AwarenessProjectsTab;